// extracted by mini-css-extract-plugin
module.exports =  {"wrapper":"wrapper__iOzQB","NoData":"NoData__lnEsa","Error":"Error__-KCym","Loading":"Loading__0as3i","clickable":"clickable__Akl5R"};